import { isNullOrEmpty } from "../../../../../../react-core/Utils/Arrays";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { BankAccountOwner } from "../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { DrawdownIncomeAmendmentModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeAmendmentModel";
import { MoneyHelper } from "../../../../../Shared/Common/MoneyHelper";
import { incomePaymentDetailsLabels } from "./Contents";

export const getBankAccountOptions = (allBankAccounts) => {
        const options = new Map();
        options.set(-1, incomePaymentDetailsLabels.wrapCash);
        if (!isNullOrEmpty(allBankAccounts)) {
            allBankAccounts.forEach((account) => {
                if (account.Owner == BankAccountOwner.Individual || account.Owner == BankAccountOwner.Joint) {
                    options.set(
                        account.BankAccountId,
                        `${account?.SortCode || ""} | ${account?.AccountNumber || ""} | ${account.HolderName || ""}`
                    );
                }
            });
        }

    return options;
};

export const getAnnualIncomeBasedOnFrequency = (incomePerPayment: Money, frequency: Frequency) => {
    const annualIncome: Money = { Amount: 0, Currency: MoneyHelper.getDefaultCurrency() };
    const incomeAmount = incomePerPayment?.Amount > 0 ? incomePerPayment?.Amount : 0;
    switch (frequency) {
        case Frequency.Monthly:
            annualIncome.Amount = incomeAmount * 12;
            break;
        case Frequency.Quarterly:
            annualIncome.Amount = incomeAmount * 4;
            break;
        case Frequency.HalfYearly:
            annualIncome.Amount = incomeAmount * 2;
            break;
        case Frequency.Yearly:
            annualIncome.Amount = incomeAmount;
            break;
    }
    return annualIncome;
};

export const getDefaultModel = (accountHierarchyId: string, subAccountHierarchyId: string) => {
    const model: DrawdownIncomeAmendmentModel = {
        // AccounthierarchyId: accountHierarchyId,
        DrawdownIncomeAmendmentInstruction: {},
    };
    model.DrawdownIncomeAmendmentInstruction = {
        HierarchyId: subAccountHierarchyId,
        GadReview: true,
        Status: InstructionStatus.Pending,
        LastModifiedOn: JsonDateParser.toJsonDateNoOffset(new Date()),
    };
    return model;
};
